import { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const STORAGE_KEY = 'fidus-cookie-consent';

export default function CookieConsent() {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) setShowConsent(true);
  }, []);

  const acceptCookies = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setShowConsent(false);
  };

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'dismissed');
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-[#e8ede4]/10 bg-[#070b12] p-4 text-[#e8ede4] shadow-[0_-8px_40px_-12px_rgba(0,0,0,0.65)]"
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
          <div className="flex-1">
            <p className="text-sm leading-relaxed text-[#d6ddcf]/85">
              We use cookies to improve your experience and analyse traffic. By clicking
              &quot;Accept&quot;, you agree to our use of cookies. See our privacy notice for
              details.
            </p>
          </div>
          <div className="flex flex-shrink-0 items-center gap-3">
            <button
              type="button"
              onClick={acceptCookies}
              className="rounded-full bg-[#e8ede4] px-6 py-2.5 text-sm font-semibold text-[#07101d] transition hover:bg-teal-100"
            >
              Accept
            </button>
            <button
              type="button"
              onClick={dismiss}
              className="rounded-full border border-[#e8ede4]/15 p-2 text-[#e8ede4]/72 transition hover:border-teal-200/45 hover:text-[#f1f5ec]"
              aria-label="Dismiss cookie notice"
            >
              <X className="h-5 w-5" aria-hidden />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
